import { z } from "zod";
import { getOrganizationSchema } from "../../organization";

export const getPartnershipParamSchema = z
	.object({
		partnershipId: z.uuid(),
	})
	.and(getOrganizationSchema);

export const getPartnershipReferenceBookingsParamSchema = z
	.object({
		referenceId: z.string().uuid(),
	})
	.and(getPartnershipParamSchema);

export type GetPartnershipParamSchema = z.infer<typeof getPartnershipParamSchema>;
export type GetPartnershipReferenceBookingsParamSchema = z.infer<
	typeof getPartnershipReferenceBookingsParamSchema
>;
